import { render, staticRenderFns } from "./SimpleTextInput.vue?vue&type=template&id=1224580c&"
import script from "./SimpleTextInput.vue?vue&type=script&lang=js&"
export * from "./SimpleTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports